
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M5.6 1C2.5 1 1 2.8 1 5.6v8.6c0 3 1.7 4.8 4.5 4.8H6v2.4c0 .9.5 1.6 1.3 1.6.5 0 1.1-.4 1.7-1l3.2-3h6.2c3 0 4.6-1.9 4.6-4.8V5.6C23 2.8 21.4 1 18.4 1zm0 2h12.8C20.2 3 21 4 21 5.7v8.5c0 1.7-.8 2.8-2.6 2.8H12c-.6 0-.8 0-1.3.5L8 20v-2.3c0-.6-.5-.7-1.1-.7H5.6c-1.8 0-2.5-1.1-2.5-2.8V5.7C3 3.9 3.9 3 5.6 3zM12 5a1 1 0 00-1 1v3H8c-.6 0-1 .4-1 1 0 .5.5 1 1 1h3v3c0 .7.6 1 1 1s1-.3 1-1v-3h3c.6 0 1-.4 1-1 0-.5-.4-1-1-1h-3V6c0-.6-.4-1-1-1z"}})])
          )
        }
      }
    